<template>
  <div class="main-container">
    <div class="main-container-title-box" style="margin-bottom: 20px">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Список пользователей </span>
        <v-icon
          @mouseover="openInfo($event)"
          @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)"
          >mdi-information</v-icon
        >
      </div>
      <div class="d-flex align-center">
        <v-btn
          v-if="typeTab == 2"
          outlined
          color="var(--app-dark-blue-1)"
          style="width: auto !important; margin-right: 20px"
          class="button-accept-outlined"
          @click="downloadTable"
        >
          Загрузить таблицу
        </v-btn>
        <input
          type="file"
          ref="downloadInput"
          accept=".xlsx, .xls, .csv"
          @change="previewFiles"
        />
        <v-text-field
          style="width: 300px; margin-bottom: 20px"
          @input="handleSearchInput"
          append-icon="mdi-magnify"
          hide-details
          label="Поиск"
          color="var(--app-dark-blue-1)"
          single-line
          v-model="search"
        ></v-text-field>
      </div>
    </div>

    <v-menu
      v-model="showInfo"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-card min-width="300px" min-height="100px">
        <div class="menu-container">
          <div class="menu-container-title">«Зарегистрированные»</div>
          <div class="menu-container-text">
            Отображает всех зарегистрированных пользователей
          </div>
          <div class="menu-container-title">
            Иконка
            <v-icon small color="#929292"> mdi-alert </v-icon>
          </div>
          <div class="menu-container-text">
            Пользователи совпали с сотрудником банка - требуется особая проверка
          </div>
          <div class="menu-container-title">
            Иконка
            <v-icon small color="#929292"> mdi-clock-outline </v-icon>
          </div>
          <div class="menu-container-text">
            Пользователи которые ожидают модерации
          </div>
          <div class="menu-container-title">
            Иконка
            <v-icon small color="#929292"> mdi-check-circle </v-icon>
          </div>
          <div class="menu-container-text">
            Пользователи которые прошли модерацию
          </div>
          <div class="menu-container-title">
            Иконка
            <v-icon small color="#929292"> mdi-alpha-a-circle</v-icon>
          </div>
          <div class="menu-container-text">
            Пользователи которые прошли автоматическую модерацию
          </div>
        </div>
      </v-card>
    </v-menu>

    <div>
      <v-tabs
        class="container-banners-tabs"
        color="var(--app-dark-blue-1)"
        v-model="typeTab"
      >
        <v-tab :disabled="isLoading"> Зарегистрированные </v-tab>
        <v-tab :disabled="isLoading"> Заблокированные </v-tab>
        <v-tab :disabled="isLoading"> Сотрудники банка </v-tab>
        <v-tab :disabled="isLoading"> Участник КСА </v-tab>
        <v-tab :disabled="isLoading"> Кандидат КСА </v-tab>
        <v-tab-item>
          <div class="container-table-box">
            <v-data-table
              :headers="tableHeaders"
              :items="items"
              :loading="isLoading"
              fixed-header
              item-key="id"
              :search="search"
              :footer-props="{
                itemsPerPageOptions: [10, 25, 50],
                'items-per-page-text': '',
              }"
              :items-per-page="optionTable.itemsPerPage"
              :server-items-length="optionTable.serverItemsLength"
              @pagination="tableChange"
              class="elevation-0 rounded-0 container-table"
              :class="{ 'container-on-loading': isLoading }"
              loading-text="Данные загружаются"
            >
              <template v-slot:body="props">
                <tbody>
                  <tr v-for="(item, index) in props.items" :key="index">
                    <td @click="openDialog(item)">
                      <v-icon
                        v-if="
                          item.moderationStatus == 'pending' &&
                          item.matches &&
                          item.matches.length > 0
                        "
                        color="var(--app-orange-1)"
                        class="mr-2"
                        >mdi-alert</v-icon
                      >

                      <v-icon
                        v-if="
                          item.moderationStatus == 'pending' && !item.matches
                        "
                        class="mr-2"
                        >mdi-clock-outline</v-icon
                      >

                      <v-icon
                        v-if="
                          item.moderationStatus == 'auto' && !item.isBlocked
                        "
                        color="var(--app-green-1)"
                        class="mr-2"
                        >mdi-alpha-a-circle</v-icon
                      >
                      <v-icon
                        v-if="
                          item.moderationStatus == 'passed' && !item.isBlocked
                        "
                        color="var(--app-dark-blue-1)"
                        class="mr-2"
                        >mdi-check-circle</v-icon
                      >
                      {{ item.lastName }} {{ item.firstName }}
                      {{ item.middleName }}
                    </td>
                    <td @click="openDialog(item)">
                      {{ item.lastActivity | moment("DD.MM.YYYY HH:mm") }}
                    </td>
                    <td @click="openDialog(item)">
                      {{ item.id }}
                    </td>

                    <td class="d-flex justify-end align-center">
                      <template v-if="roleAdminUser('shareholders_club')">
                        <div @click="openDialogInformation(item)">
                          <v-icon color="var(--app-dark-blue-1)"
                            >mdi-information-outline</v-icon
                          >
                        </div>
                        <div @click="deleteUser(item)" class="ml-4">
                          <v-icon color="var(--app-red-1)"
                            >mdi-delete-outline</v-icon
                          >
                        </div>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="container-table-box">
            <v-data-table
              :headers="tableHeadersErr"
              :items="items"
              fixed-header
              item-key="id"
              @click:row="openDialog"
              :loading="isLoading"
              :class="{ 'container-on-loading': isLoading }"
              loading-text="Данные загружаются"
              :search="search"
              :footer-props="{
                itemsPerPageOptions: [10, 25, 50],
                'items-per-page-text': '',
              }"
              :items-per-page="optionTableBlock.itemsPerPage"
              :server-items-length="optionTableBlock.serverItemsLength"
              @pagination="tableChangeBlock"
              class="elevation-0 rounded-0 container-table"
            >
              <template v-slot:[`item.name`]="{ item }">
                {{ item.lastName }} {{ item.firstName }} {{ item.middleName }}
              </template>
              <template v-slot:[`item.reason`]="{ item }">
                <template v-if="item.blocking">
                  {{ item.blocking.reason.title }}
                </template>
              </template>
            </v-data-table>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="container-table-box">
            <v-data-table
              :headers="tableHeadersEmp"
              :items="items"
              :search="search"
              fixed-header
              item-key="id"
              @click:row="openDialog"
              :loading="isLoading"
              :class="{ 'container-on-loading': isLoading }"
              loading-text="Данные загружаются"
              :footer-props="{
                itemsPerPageOptions: [10, 25, 50],
                'items-per-page-text': '',
              }"
              :items-per-page="optionTableBank.itemsPerPage"
              :server-items-length="optionTableBank.serverItemsLength"
              @pagination="tableChangeBank"
              class="elevation-0 rounded-0 container-table"
            >
              <template v-slot:[`item.name`]="{ item }">
                {{ item.lastName }} {{ item.firstName }} {{ item.middleName }}
              </template>

              <template v-slot:[`item.photo`]="{ item }">
                <img v-if="item.photo" class="table-img" :src="item.photo" />
                <div v-else class="table-not-image">
                  <v-icon size="20px">mdi-account</v-icon>
                </div>
              </template>
            </v-data-table>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="container-table-box">
            <v-data-table
              :headers="tableHeadersEmp"
              :items="items"
              :search="search"
              fixed-header
              item-key="id"
              :loading="isLoading"
              :class="{ 'container-on-loading': isLoading }"
              loading-text="Данные загружаются"
              @click:row="openDialog"
              :footer-props="{
                itemsPerPageOptions: [10, 25, 50],
                'items-per-page-text': '',
              }"
              :items-per-page="optionTableKsa.itemsPerPage"
              :server-items-length="optionTableKsa.serverItemsLength"
              @pagination="tableChangeKsa"
              class="elevation-0 rounded-0 container-table"
            >
              <template v-slot:[`item.name`]="{ item }">
                {{ item.lastName }} {{ item.firstName }} {{ item.middleName }}
              </template>

              <template v-slot:[`item.photo`]="{ item }">
                <img v-if="item.photo" class="table-img" :src="item.photo" />
                <div v-else class="table-not-image">
                  <v-icon size="20px">mdi-account</v-icon>
                </div>
              </template>
            </v-data-table>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="container-table-box">
            <v-data-table
              :headers="tableHeadersCandidates"
              :items="items"
              fixed-header
              item-key="id"
              @click:row="openCandidateDetail"
              :footer-props="{}"
              :loading="isLoading"
              :class="{ 'container-on-loading': isLoading }"
              loading-text="Данные загружаются"
              class="elevation-0 rounded-0 container-table"
            >
              <template v-slot:[`item.name`]="{ item }">
                {{ item.user?.lastName }} {{ item.user?.firstName }}
                {{ item.user?.middleName }}
              </template>
              <template v-slot:[`item.phoneNumber`]="{ item }">
                {{ item.phoneNumber }}
              </template>
            </v-data-table>
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
    <v-divider></v-divider>

    <v-dialog
      :width="
        selectedItem.moderationStatus == 'pending' &&
        selectedItem.matches &&
        selectedItem.matches.length > 0
          ? '910px'
          : '500px'
      "
      height="auto"
      persistent
      v-model="dialog"
    >
      <v-card
        :width="
          selectedItem.moderationStatus == 'pending' &&
          selectedItem.matches &&
          selectedItem.matches.length > 0
            ? '910px'
            : '500px'
        "
        height="auto"
        class="rounded-0"
      >
        <v-form ref="formFirst">
          <v-card-title class="dialog-title">
            <span v-if="selectedItem.moderationStatus == 'passed'" class="title"
              >Профиль</span
            >
            <span v-else class="title">Модерация профиля</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text
            class="dialog-description"
            v-if="
              selectedItem.moderationStatus == 'passed' &&
              !selectedItem.isBlocked
            "
          >
            <div
              class="dialog-description-image d-flex align-center justify-center"
            >
              <img v-if="selectedItem.photo" :src="selectedItem.photo" />
              <div v-else><v-icon size="50px">mdi-account</v-icon></div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">ФИО</div>
              <div class="ditem-value">
                {{ selectedItem.lastName }} {{ selectedItem.firstName }}
                {{ selectedItem.middleName }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Телефон</div>
              <div class="ditem-value">
                {{ selectedItem.phoneNumber }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Эл. почта</div>
              <div class="ditem-value">
                {{ selectedItem.email }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">ID пользователя</div>
              <div class="ditem-value">
                {{ selectedItem.id }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Дата регистрации</div>
              <div class="ditem-value">
                {{ selectedItem.dateCreated | moment("DD.MM.YYYY HH:mm") }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">
                Дата последней <br />
                активности
              </div>
              <div class="ditem-value">
                {{ selectedItem.lastActivity | moment("DD.MM.YYYY HH:mm") }}
              </div>
            </div>
            <div
              class="dialog-item"
              v-if="selectedItem.isKsaMember && !editedMode"
            >
              <div class="ditem-title">Участник КСА</div>
              <div class="ditem-value">
                <v-icon color="var(--app-green-1)"> mdi-check-circle </v-icon>
              </div>
            </div>
            <div
              class="dialog-item"
              v-if="selectedItem.isBankEmployee && !editedMode"
            >
              <div class="ditem-title">Сотрудник ВТБ</div>
              <div class="ditem-value">
                <v-icon color="var(--app-green-1)"> mdi-check-circle </v-icon>
              </div>
            </div>
            <div
              class="dialog-item"
              v-if="selectedItem.position && !editedMode"
            >
              <div class="ditem-title">Должность</div>
              <div class="ditem-value">
                {{ selectedItem.position }}
              </div>
            </div>

            <div class="dialog-item" v-if="editedMode">
              <div class="ditem-title">Участник КСА</div>
              <div class="ditem-value">
                <v-switch
                  hide-details
                  v-model="selectedItem.isKsaMember"
                  color="var(--app-green-1)"
                ></v-switch>
              </div>
            </div>
            <div class="dialog-item" v-if="editedMode">
              <div class="ditem-title">Сотрудник ВТБ</div>
              <div class="ditem-value">
                <v-switch
                  hide-details
                  v-model="selectedItem.isBankEmployee"
                  color="var(--app-green-1)"
                ></v-switch>
              </div>
            </div>
            <div
              v-if="
                editedMode &&
                (selectedItem.isKsaMember || selectedItem.isBankEmployee)
              "
            >
              <v-text-field
                label="Должность сотрудника"
                required
                type="text"
                outlined
                v-model="selectedItem.position"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-text
            class="dialog-description"
            v-if="
              selectedItem.moderationStatus == 'pending' &&
              !selectedItem.matches
            "
          >
            <div
              class="dialog-description-image d-flex align-center justify-center"
            >
              <img v-if="selectedItem.photo" :src="selectedItem.photo" />
              <div v-else><v-icon size="50px">mdi-account</v-icon></div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">ФИО</div>
              <div class="ditem-value">
                {{ selectedItem.lastName }} {{ selectedItem.firstName }}
                {{ selectedItem.middleName }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Телефон</div>
              <div class="ditem-value">
                {{ selectedItem.phoneNumber }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Эл. почта</div>
              <div class="ditem-value">
                {{ selectedItem.email }}
              </div>
            </div>

            <div class="dialog-item">
              <div class="ditem-title">Участник КСА</div>
              <div class="ditem-value">
                <v-switch
                  hide-details
                  v-model="selectedItem.isKsaMember"
                  color="var(--app-green-1)"
                ></v-switch>
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Сотрудник ВТБ</div>
              <div class="ditem-value">
                <v-switch
                  hide-details
                  v-model="selectedItem.isBankEmployee"
                  color="var(--app-green-1)"
                ></v-switch>
              </div>
            </div>
            <div v-if="selectedItem.isKsaMember || selectedItem.isBankEmployee">
              <v-text-field
                label="Должность сотрудника"
                required
                type="text"
                outlined
                v-model="selectedItem.position"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-text
            v-if="
              selectedItem.moderationStatus == 'pending' &&
              selectedItem.matches &&
              selectedItem.matches.length > 0
            "
            style="padding: 0px !important"
          >
            <div class="d-flex">
              <div
                class="pa-6"
                style="border-right: 1px solid rgb(224, 224, 224); width: 50%"
              >
                <div class="dialog-description-subtitle">
                  Новый пользователь
                </div>
                <div class="dialog-description-image d-flex align-center">
                  <img v-if="selectedItem.photo" :src="selectedItem.photo" />
                  <div v-else><v-icon size="50px">mdi-account</v-icon></div>
                </div>
                <div class="dialog-item">
                  <div
                    class="ditem-title d-flex justify-space-between align-start"
                  >
                    ФИО
                    <v-icon
                      v-if="checkName(selectedItem, selectedCopyItem)"
                      class="mr-3"
                      color="var(--app-orange-1)"
                      >mdi-alert</v-icon
                    >
                  </div>
                  <div class="ditem-value">
                    {{ selectedItem.lastName }} {{ selectedItem.firstName }}
                    {{ selectedItem.middleName }}
                  </div>
                </div>
                <div class="dialog-item">
                  <div
                    class="ditem-title d-flex justify-space-between align-start"
                  >
                    Телефон
                    <v-icon
                      v-if="
                        selectedItem.phoneNumber == selectedCopyItem.phoneNumber
                      "
                      class="mr-3"
                      color="var(--app-orange-1)"
                      >mdi-alert</v-icon
                    >
                  </div>
                  <div class="ditem-value">
                    {{ selectedItem.phoneNumber }}
                  </div>
                </div>
                <div class="dialog-item">
                  <div
                    class="ditem-title d-flex justify-space-between align-start"
                  >
                    Эл. почта
                    <v-icon
                      v-if="selectedItem.email == selectedCopyItem.email"
                      class="mr-3"
                      color="var(--app-orange-1)"
                      >mdi-alert</v-icon
                    >
                  </div>
                  <div class="ditem-value">
                    {{ selectedItem.email }}
                  </div>
                </div>

                <div class="dialog-item">
                  <div class="ditem-title">Участник КСА</div>
                  <div class="ditem-value">
                    <v-switch
                      hide-details
                      v-model="selectedItem.isKsaMember"
                      color="var(--app-green-1)"
                    ></v-switch>
                  </div>
                </div>
                <div class="dialog-item">
                  <div class="ditem-title">Сотрудник ВТБ</div>
                  <div class="ditem-value">
                    <v-switch
                      hide-details
                      v-model="selectedItem.isBankEmployee"
                      color="var(--app-green-1)"
                    ></v-switch>
                  </div>
                </div>
                <div
                  v-if="selectedItem.isKsaMember || selectedItem.isBankEmployee"
                >
                  <v-text-field
                    label="Должность сотрудника"
                    required
                    type="text"
                    outlined
                    v-model="selectedItem.position"
                  ></v-text-field>
                </div>
              </div>
              <div class="pa-6" style="width: 50%">
                <div class="dialog-description-subtitle">Сотрудник банка</div>
                <div class="dialog-description-image d-flex align-center">
                  <img
                    v-if="selectedCopyItem.photo"
                    :src="selectedCopyItem.photo"
                  />
                  <div v-else><v-icon size="50px">mdi-account</v-icon></div>
                </div>
                <div class="dialog-item">
                  <div class="ditem-title">ФИО</div>
                  <div class="ditem-value">
                    {{ selectedCopyItem.lastName }}
                    {{ selectedCopyItem.firstName }}
                    {{ selectedCopyItem.middleName }}
                  </div>
                </div>
                <div class="dialog-item">
                  <div class="ditem-title">Телефон</div>
                  <div class="ditem-value">
                    {{ selectedCopyItem.phoneNumber }}
                  </div>
                </div>
                <div class="dialog-item">
                  <div class="ditem-title">Эл. почта</div>
                  <div class="ditem-value">
                    {{ selectedCopyItem.email }}
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-text
            class="dialog-description"
            v-if="
              selectedItem.moderationStatus == 'passed' &&
              selectedItem.isBlocked
            "
          >
            <v-alert text type="error" class="d-flex align-center">
              <div>
                {{ selectedItem.blocking.reason.title }}
              </div>
            </v-alert>
            <div
              class="dialog-description-image d-flex align-center justify-center"
            >
              <img v-if="selectedItem.photo" :src="selectedItem.photo" />
              <div v-else><v-icon size="50px">mdi-account</v-icon></div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">ФИО</div>
              <div class="ditem-value">
                {{ selectedItem.lastName }} {{ selectedItem.firstName }}
                {{ selectedItem.middleName }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Телефон</div>
              <div class="ditem-value">
                {{ selectedItem.phoneNumber }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Эл. почта</div>
              <div class="ditem-value">
                {{ selectedItem.email }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">ID пользователя</div>
              <div class="ditem-value">
                {{ selectedItem.id }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Дата регистрации</div>
              <div class="ditem-value">
                {{ selectedItem.dateCreated | moment("DD.MM.YYYY HH:mm") }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">
                Дата последней <br />
                активности
              </div>
              <div class="ditem-value">
                {{ selectedItem.lastActivity | moment("DD.MM.YYYY HH:mm") }}
              </div>
            </div>
            <div
              class="dialog-item"
              v-if="selectedItem.isKsaMember && !editedMode"
            >
              <div class="ditem-title">Участник КСА</div>
              <div class="ditem-value">
                <v-icon color="var(--app-green-1)"> mdi-check-circle </v-icon>
              </div>
            </div>
            <div
              class="dialog-item"
              v-if="selectedItem.isBankEmployee && !editedMode"
            >
              <div class="ditem-title">Сотрудник ВТБ</div>
              <div class="ditem-value">
                <v-icon color="var(--app-green-1)"> mdi-check-circle </v-icon>
              </div>
            </div>
            <div
              class="dialog-item"
              v-if="selectedItem.position && !editedMode"
            >
              <div class="ditem-title">Должность</div>
              <div class="ditem-value">
                {{ selectedItem.position }}
              </div>
            </div>
          </v-card-text>

          <div
            class="d-flex"
            v-if="
              selectedItem.moderationStatus == 'pending' &&
              selectedItem.matches &&
              selectedItem.matches.length > 0
            "
          >
            <v-card-actions
              style="width: 50%; border-right: 1px solid rgb(224, 224, 224)"
              class="dialog-buttons"
            >
              <v-btn
                @click="dialogReason = true"
                :disabled="loading"
                outlined
                style="width: 120px !important"
                color="var(--app-red-1)"
                class="button-accept-outlined"
              >
                Отклонить
              </v-btn>
              <v-btn
                :loading="loading"
                style="width: 120px !important"
                @click="moderationCompleted"
                color="var(--app-green-1)"
                class="button-accept-outlined"
                outlined
              >
                Принять
              </v-btn>
            </v-card-actions>
            <v-card-actions
              style="width: 50%"
              class="dialog-buttons"
              v-if="selectedItem.matches.length > 1"
            >
              <v-btn
                v-if="!showDialogTable"
                @click="showDialogTable = true"
                outlined
                style="width: 177px !important"
                color="var(--app-dark-blue-1)"
                class="button-accept-outlined"
              >
                Еще совпадения
              </v-btn>
            </v-card-actions>
          </div>

          <v-card-actions
            class="dialog-buttons"
            v-else-if="
              selectedItem.moderationStatus == 'passed' &&
              !selectedItem.isBlocked
            "
          >
            <v-btn
              v-if="!editedMode"
              @click="editedMode = true"
              outlined
              style="width: auto !important"
              color="var(--app-green-1)"
              class="button-accept-outlined"
            >
              Редактировать
            </v-btn>
            <v-btn
              v-else
              @click="saveEditItem"
              outlined
              :loading="loading"
              style="width: auto !important"
              color="var(--app-green-1)"
              class="button-accept-outlined"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="!editedMode"
              @click="dialogReasonBlock = true"
              outlined
              style="width: auto !important"
              color="var(--app-red-1)"
              class="button-accept-outlined"
            >
              Заблокировать
            </v-btn>
          </v-card-actions>
          <v-card-actions
            class="dialog-buttons justify-end"
            v-else-if="
              selectedItem.moderationStatus == 'passed' &&
              selectedItem.isBlocked
            "
          >
            <v-btn
              @click="blockingUser(false)"
              :loading="loading"
              outlined
              style="width: auto !important"
              color="var(--app-green-1)"
              class="button-accept-outlined"
            >
              Разблокировать
            </v-btn>
          </v-card-actions>
          <v-card-actions class="dialog-buttons" v-else>
            <v-btn
              @click="dialogReason = true"
              outlined
              :disabled="loading"
              style="width: 120px !important"
              color="var(--app-red-1)"
              class="button-accept-outlined"
            >
              Отклонить
            </v-btn>
            <v-btn
              :loading="loading"
              style="width: 120px !important"
              @click="moderationCompleted"
              color="var(--app-green-1)"
              class="button-accept-outlined"
              outlined
            >
              Принять
            </v-btn>
          </v-card-actions>

          <div class="dialog-table-container" v-if="showDialogTable">
            <div class="dialog-table-container-title">
              <div class="table-container-title-text">Еще совпадения</div>
              <v-btn
                @click="showDialogTable = false"
                outlined
                style="width: 110px !important"
                color="var(--app-dark-blue-1)"
                class="button-accept-outlined"
              >
                Скрыть
              </v-btn>
            </div>
            <v-data-table
              :headers="tableHeadersEmp"
              :items="
                selectedItem.matches.filter((i) => i.id != selectedCopyItem.id)
              "
              fixed-header
              item-key="id"
              :disable-pagination="true"
              :hide-default-footer="true"
              class="elevation-0 rounded-0"
              @click:row="onClickDialogTable"
            >
              <template v-slot:[`item.name`]="{ item }">
                {{ item.lastName }} {{ item.firstName }} {{ item.middleName }}
              </template>

              <template v-slot:[`item.photo`]="{ item }">
                <img v-if="item.photo" class="table-img" :src="item.photo" />
                <div v-else class="table-not-image">
                  <v-icon size="20px">mdi-account</v-icon>
                </div>
              </template>
            </v-data-table>
          </div>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog width="570px" height="auto" persistent v-model="dialogReason">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formSecond">
          <v-card-title class="dialog-title">
            <span class="title">Причина отклонения</span>

            <v-icon @click="dialogReason = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-select
              :items="reasons"
              outlined
              item-text="text"
              item-value="id"
              :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']"
              v-model="selectedItem.reasonBlock"
              label="Выберите причину"
            ></v-select>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn
              @click="dialogReason = false"
              outlined
              style="width: 120px !important"
              color="var(--app-green-1)"
              class="button-accept-outlined"
            >
              Отмена
            </v-btn>
            <v-btn
              :loading="loading"
              style="width: 120px !important"
              color="var(--app-red-1)"
              @click="blockUser"
              class="button-accept-outlined"
              outlined
            >
              Отклонить
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      width="570px"
      height="auto"
      persistent
      v-model="dialogReasonBlock"
    >
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formSecond">
          <v-card-title class="dialog-title">
            <span class="title">Причина блокировки</span>

            <v-icon @click="dialogReasonBlock = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-select
              :items="reasonsBlock"
              outlined
              item-text="title"
              item-value="id"
              :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']"
              v-model="selectedItem.reasonBlock"
              label="Выберите причину"
            ></v-select>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn
              @click="dialogReasonBlock = false"
              outlined
              style="width: 120px !important"
              color="var(--app-green-1)"
              class="button-accept-outlined"
            >
              Отмена
            </v-btn>
            <v-btn
              :loading="loading"
              style="width: 120px !important"
              color="var(--app-red-1)"
              @click="blockingUser(true)"
              class="button-accept-outlined"
              outlined
            >
              Блокировка
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog width="800px" height="auto" persistent v-model="dialogInfo">
      <v-card width="800px" height="auto" class="rounded-0">
        <v-form lazy-validation ref="push">
          <v-card-title class="dialog-title">
            <span class="title">Список сессий пользователя</span>
            <v-icon @click="dialogInfo = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-simple-table
              fixed-header
              height="400px"
              v-if="sessions.length > 0"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Тип устройства</th>
                    <th class="text-left">Модель устройства</th>
                    <th class="text-left">Дата создания</th>
                    <th class="text-left">Последняя активность</th>

                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in sessions" :key="item.id">
                    <td @click="openDetailSession(item)" class="text-left">
                      {{ item.deviceType }}
                    </td>
                    <td @click="openDetailSession(item)" class="text-left">
                      {{ item.deviceModel }}
                    </td>

                    <td @click="openDetailSession(item)" class="text-left">
                      <template v-if="item.dateCreated">
                        {{ item.dateCreated | moment("HH:mm DD.MM.YYYY") }}
                      </template>
                    </td>
                    <td @click="openDetailSession(item)" class="text-left">
                      <template v-if="item.lastActivity">
                        {{ item.lastActivity | moment("HH:mm DD.MM.YYYY") }}
                      </template>
                    </td>

                    <td>
                      <div @click="deleteUserSession(item)">
                        <v-icon color="var(--app-red-1)"
                          >mdi-delete-outline</v-icon
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div
              v-else
              class="d-flex align-center justify-center mt-10 mb-10"
              style="font-size: 18px"
            >
              Нет данных
            </div>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="dialogInfo = false" class="button-accept">
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      width="700px"
      height="auto"
      persistent
      v-model="dialogSessionInfo"
    >
      <v-card width="700px" height="auto" class="rounded-0">
        <v-card-title class="dialog-title">
          <span class="title">Детальная информация</span>
          <v-icon @click="dialogSessionInfo = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="dialog-description">
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">ID:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.id }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">ID пользователя:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.userId }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Бундл ID:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.appBundle }}
            </div>
          </div>

          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Версия приложения:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.appVersion }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Тип приложения:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.deviceType }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Модель устройства:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.deviceModel }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Название магазина:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.marketName }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Версия системы:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.systemVersion }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">ID устройства:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.deviceId }}
            </div>
          </div>

          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Регион пользователя:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.locale }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Регион:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.region }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Город:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.city }}
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Временная зона:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.timeZone }}
            </div>
          </div>

          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Дата создания:</div>
            <div class="dialog-view-item-text">
              <template v-if="detailSession.dateCreated">
                {{ detailSession.dateCreated | moment(" HH:mm DD.MM.YYYY ") }}
              </template>
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Последняя активность:</div>
            <div class="dialog-view-item-text">
              <template v-if="detailSession.lastActivity">
                {{ detailSession.lastActivity | moment(" HH:mm DD.MM.YYYY ") }}
              </template>
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">
              Ограничение по времени отправки пушей:
            </div>
            <div class="dialog-view-item-text">
              <span v-if="detailSession.isNotificationTime">Да</span>
              <span v-else>Нет</span>
            </div>
          </div>

          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Пуш отпрален:</div>
            <div class="dialog-view-item-text">
              <span v-if="detailSession.toSendPush">Да</span>
              <span v-else>Нет</span>
            </div>
          </div>
          <div class="dialog-view-item">
            <div class="dialog-view-item-title">Token устройства:</div>
            <div class="dialog-view-item-text">
              {{ detailSession.deviceToken }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    dialog: false,
    dialogReason: false,
    dialogInfo: false,
    dialogReasonBlock: false,
    dialogSessionInfo: false,
    debounceTimeout: null,
    selectedItem: {},
    selectedCopyItem: {},
    detailSession: {},
    typeTab: 0,
    search: "",
    reasons: [],
    showDialogTable: false,
    reasonsBlock: [],
    items: [],
    isLoading: false,
    sessions: [],

    cache: {},
    cacheExpiry: 2 * 60 * 1000,

    tableHeadersErr: [
      { text: "ФИО", sortable: false, value: "name" },
      { text: "Причина", sortable: false, value: "reason" },
    ],

    tableHeadersCandidates: [
      { text: "ФИО", sortable: false, value: "name" },
      { text: "Номер телефона", sortable: false, value: "phoneNumber" },
    ],
    tableHeadersEmp: [
      { text: "Фото", sortable: false, value: "photo" },
      { text: "ФИО", sortable: false, value: "name" },
      { text: "Телефон", sortable: false, value: "phoneNumber" },
      { text: "Эл. почта", sortable: false, value: "email" },
    ],
    tableHeaders: [
      {
        text: "ФИО",
        sortable: false,
        value: "name",
      },
      {
        text: "Последняя активность",
        value: "date",
        sortable: false,
      },
      {
        text: "ID",
        sortable: false,
        value: "id",
      },

      {
        text: "",
        sortable: false,
        value: "actions",
      },
    ],
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    optionTableBlock: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    optionTableBank: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    optionTableKsa: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },

    loading: false,
    tableDownloadItem: null,
    editedMode: false,
  }),

  methods: {
    downloadTable() {
      this.$refs.downloadInput.click();
    },
    previewFiles(event) {
      if (event.target.files[0]) {
        this.tableDownloadItem = event.target.files[0];
        let formData = new FormData();
        formData.append("file", this.tableDownloadItem);
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/club/user/table",
            formData,
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => {
            this.tableDownloadItem = null;
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    closeDialog() {
      this.dialog = false;

      setTimeout(() => {
        this.$refs.formFirst.reset();
        this.selectedItem = {};
        this.showDialogTable = false;
        this.editedMode = false;
      }, 100);
    },
    checkName(item, secondItem) {
      const firstArr = [item.lastName, item.firstName, item.middleName];
      const secondArr = [
        secondItem.lastName ? secondItem.lastName : "-",
        secondItem.firstName ? secondItem.firstName : " ",
        secondItem.middleName ? secondItem.middleName : " ",
      ];

      let newArr = firstArr.filter((i) => {
        for (const el of secondArr) {
          if (i && el) {
            if (i.toLowerCase() == el.toLowerCase()) {
              return i;
            }
          }
        }
      });
      if (newArr[0]) {
        return true;
      } else {
        return false;
      }
    },
    openCandidateDetail(item) {
      this.$router.push({
        name: "DetailCandidate",
        params: { id: item.id },
      });
    },
    onClickDialogTable(item) {
      this.selectedCopyItem = item;
    },
    openDetailSession(item) {
      this.dialogSessionInfo = true;
      this.detailSession = item;
    },
    openDialogInformation(item) {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/user/session/list",
          {
            userId: item.id,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.selectedItem = item;
          this.dialogInfo = true;
          this.sessions = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteUserSession(item) {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/club/user/session", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            sessionId: item.id,
          },
        })
        .then(() => {
          this.openDialogInformation(this.selectedItem);
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteUser(item) {
      if (confirm()) {
        this.$axios
          .delete(this.$store.getters.apiAdminPanelV2 + "/club/user", {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
            params: {
              userId: item.id,
            },
          })
          .then(() => {
            this.getItems();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    openDialog(item) {
      if (item.matches != null && item.moderationStatus == "pending") {
        this.selectedItem = Object.assign({}, item);
        if (this.selectedItem.matches && this.selectedItem.matches.length > 0) {
          this.selectedCopyItem = this.selectedItem.matches[0];
        }
        this.dialog = true;
      } else {
        this.$router.push({ name: "ChatUser", params: { id: item.id } });
      }
    },
    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },

    handleSearchInput() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.getItems(true);
      }, 500);
    },

    goToDetail(item) {
      this.$router.push({ name: "ChatUser", params: { id: item.id } });
    },
    checkParams() {
      if (this.$route.params.tab) {
        this.typeTab = this.$route.params.tab;
      }
    },

    getKsaCandidates() {
      this.isLoading = true;
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + "/ksa-election-candidates", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        })
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    getItems(search) {
      if (this.isLoading) return;
      this.isLoading = true;
      const cacheKey = `${this.typeTab}-${this.search}-${JSON.stringify(
        this.optionTable
      )}`;
      if (
        this.cache[cacheKey] &&
        Date.now() - this.cache[cacheKey].timestamp < this.cacheExpiry
      ) {
        this.items = this.cache[cacheKey].data;
        this.isLoading = false;
        return;
      }

      if (this.typeTab === 4) {
        this.getKsaCandidates();
        this.isLoading = false;
        return;
      }
      const statuses = ["registred", "blocked", "bank_employee", "ksa_member"];
      const optionTables = [
        "optionTable",
        "optionTableBlock",
        "optionTableBank",
        "optionTableKsa",
      ];
      if (search) {
        this[optionTables[this.typeTab]].page = 1;
      }

      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/user/list",
          {
            optionTable: this[optionTables[this.typeTab]],
            status: statuses[this.typeTab],
            search: this.search,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.items = res.data.items;
          this.isLoading = false;
          this[optionTables[this.typeTab]] = res.data.optionTable;
          this.cache[cacheKey] = {
            data: res.data.items,
            timestamp: Date.now(),
          };
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getReasons() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 +
            "/club/moderation/refuse/reason/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.reasons = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getReasonsBlocks() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/blocking/reason/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.reasonsBlock = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    tableChange(data) {
      this.optionTable.page = data.page;
      this.optionTable.itemsPerPage = data.itemsPerPage;
      this.getItems();
    },
    tableChangeBlock(data) {
      this.optionTableBlock.page = data.page;
      this.optionTableBlock.itemsPerPage = data.itemsPerPage;
      this.getItems();
    },
    tableChangeBank(data) {
      this.optionTableBank.page = data.page;
      this.optionTableBank.itemsPerPage = data.itemsPerPage;
      this.getItems();
    },
    tableChangeKsa(data) {
      this.optionTableKsa.page = data.page;
      this.optionTableKsa.itemsPerPage = data.itemsPerPage;
      this.getItems();
    },

    blockUser() {
      this.loading = true;
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/user/moderation",
          {
            moderationStatus: "refused",
            userId: this.selectedItem.id,
            reasonId: this.selectedItem.reasonBlock,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.dialogReason = false;
          this.dialog = false;
          this.selectedItem = {};
          this.getItems();
          this.loading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.loading = false;
        });
    },
    blockingUser(item) {
      this.loading = true;
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/user/blocking",
          {
            toBlock: item,
            userId: this.selectedItem.id,
            reasonId: item ? this.selectedItem.reasonBlock : "",
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.dialogReasonBlock = false;
          this.dialog = false;
          this.selectedItem = {};
          this.getItems();
          this.loading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.loading = false;
        });
    },

    moderationCompleted() {
      this.loading = true;
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/user/moderation",
          {
            moderationStatus: "passed",
            userId: this.selectedItem.id,
            isBankEmployee: this.selectedItem.isBankEmployee,
            isKsaMember: this.selectedItem.isKsaMember,
            position: this.selectedItem.position,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.dialog = false;
          this.selectedItem = {};
          this.getItems();
          this.loading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    saveEditItem() {
      this.loading = true;

      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV2 + "/club/user",
          {
            userId: this.selectedItem.id,
            isBankEmployee: this.selectedItem.isBankEmployee,
            isKsaMember: this.selectedItem.isKsaMember,
            position:
              !this.selectedItem.isBankEmployee &&
              !this.selectedItem.isKsaMember
                ? ""
                : this.selectedItem.position,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.dialog = false;
          this.editedMode = false;
          this.selectedItem = {};
          this.getItems();
          this.loading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.loading = false;
        });
    },
  },
  watch: {
    typeTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getItems();
      }
    },
  },
  mounted() {},
  created() {
    this.checkParams();
    this.getItems();
    this.getReasons();
    this.getReasonsBlocks();
  },
};
</script>
<style lang="scss" scoped>
input[type="file"] {
  display: none;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > div
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.v-data-table > .v-data-table__wrapper > table > tbody > div > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 48px;
}

.v-tab {
  text-transform: none;
  font-size: 1rem;
  line-height: 1rem;
  letter-spacing: normal;
  font-weight: 400;
}

.table-img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
}

.table-not-image {
  width: 30px;
  height: 30px;
  background: #d8d8d8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container-table-box {
  min-height: 300px;
  height: calc(100vh - 242px) !important;
  overflow: auto;

  .container-on-loading {
    ::v-deep(.v-data-table__progress) {
      position: relative !important;
      height: 6px !important;
      visibility: visible !important;
    }

    ::v-deep(.v-data-table__progress) th {
      padding: 0 !important;
      overflow: hidden !important;
    }
  }

  .container-table {
    height: calc(100vh - 242px) !important;
    min-height: calc(100vh - 242px) !important;
    max-height: calc(100vh - 242px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.dialog-description-image {
  margin-bottom: 20px;

  img {
    width: 190px;
    height: 208px;
    object-fit: cover;
  }

  div {
    width: 190px;
    height: 208px;
    background: #d8d8d8;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.dialog-description-subtitle {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 18px;
}

.dialog-table-container {
  border-top: 1px solid rgb(224, 224, 224);

  .dialog-table-container-title {
    display: flex;
    justify-content: space-between;
    padding: 40px 24px;

    .table-container-title-text {
      font-size: 28px;
      font-weight: 600;
    }
  }
}

.dialog-view-item {
  display: flex;
  margin-bottom: 10px;

  .dialog-view-item-title {
    width: 200px;
  }

  .dialog-view-item-text {
    color: black;
    width: 450px;
    word-break: break-all;
  }
}
</style>
